import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule} from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { BuilderComponent } from './builder.component';
import { AuthGuard } from '../guards/auth.guard';
import { SaveGuard } from '../guards/save.guard';
import { VarModule } from '../directives/ngVar';
import { ListingModule } from '../components/listing/listing.module';
import { SearchDialogModule } from '../components/search-dialog/search-dialog.module';
import { DirectivesModule } from '../directives/directive.module';
import { PublishCompassDialogModule } from '../components/publish-compass-dialog/publish-compass-dialog.module';
import { CompassPieceDialogModule } from '../components/compass-piece-dialog/compass-piece-dialog.module';
import { AssessmentPreviewDialogModule } from '../components/assessment-preview-dialog/assessment-preview-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    DirectivesModule,
    AssessmentPreviewDialogModule,
    VarModule,
    ListingModule,
    RouterModule.forChild([
      {
        path: 'builder',
        canActivate: [AuthGuard],
        canDeactivate: [SaveGuard],
        component: BuilderComponent,
        children: []
      }
    ])
  ],
  declarations: [
    BuilderComponent
  ],
  exports: [
    BuilderComponent
  ],
  providers: [
    SearchDialogModule,
    PublishCompassDialogModule,
    CompassPieceDialogModule,
    AssessmentPreviewDialogModule
  ]
})
export class BuilderModule {}
